import { render, staticRenderFns } from "./ModalEditExternalLink.vue?vue&type=template&id=495072bf"
import script from "./ModalEditExternalLink.vue?vue&type=script&lang=js"
export * from "./ModalEditExternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports